<template>

    <trax-ui-ajax-data-table 
        :id="id" :bus="bus" :titles="titles" :props="props" :endpoint="endpoint" :endpoint-params="endpointParams"
        :cols="cols" :header="header" :header-color="headerColor"
        :paging="paging" :page-length="100" :searching="searching"
        order-column="1" order-dir="asc"
        ref="registrations"
    ></trax-ui-ajax-data-table>
    
</template>

<script>
    export default {
    
        props: {
            id: { default: 'home-registrations' },
            header: { default: 1 },
            headerColor: { default: 'primary' },
            paging: { default: 1 },
            searching: { default: 1 },
            bus: null
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                cols: [
                    {},
                    {},
                    {},
                    {},
                    {},
                    {width: '20px'},
                ],
                titles: [
                    lang.polaris.training.program,
                    lang.polaris.account.group,
                    lang.polaris.form.status,
                    lang.polaris.training.starting,
                    lang.polaris.training.ending,
                    ''
                ],
                props: [
                    {source: this.program, order: 'program.name' },
                    {source: this.cohort, order: 'cohort.name' },
                    {source: this.status },
                    {source: this.startDate, order: 'start_date' },
                    {source: this.endDate, order: 'end_date' },
                    {source: this.pinHtml },
                ],
                endpoint: app_url+"polaris/api/front/registrations",
                endpointParams: {
                    relations: ['program', 'cohort'],
                    accessors: ['is_pinned'],
                },
                status_select: data.status_select
            }
        },
        
        mounted() {
            var that = this
            $('#'+this.id+'-table tbody').on( 'click', '.btn', function() {
                that.pinIt($(this).data('id'));
            });
        },

        methods: {
        
            // Columns rendering

            program(data, type, row, meta) {
                var html = this.link(row, row.program.name);
                if (row.program.status == 'maintenance') {
                    html += '<br><span class="badge badge-warning">Maintenance</span>'
                }
                return html;
            },

            cohort(data, type, row, meta) {
                var html = this.link(row, row.cohort.name, true);
                if (row.cohort.status == 'maintenance') {
                    html += '<br><span class="badge badge-warning">Maintenance</span>'
                }
                return html;
            },

            status(data, type, row, meta) {

                // Registration status
                var label = this.status_select.find(status => status.value == row.status).name
                var color = 'info';
                if (row.status == 'active') color = 'success';
                else if (row.status == 'maintenance') color = 'warning';
                else if (row.status == 'archived') color = 'default';

                // Group or program maintenance
                /*
                if (row.status == 'active' && (row.cohort.status == 'maintenance' || row.program.status == 'maintenance')) {
                    row.status = 'maintenance';
                    label = this.lang.polaris.options.maintenance;
                    color = 'warning';
                }
                */

                // HTML
                var html = '<span class="badge badge-'+color+'">'+label+'</span>';
                return this.link(row, html);
            },

            startDate(data, type, row, meta) {
                if (!row.start_date) return '';
                if (moment(row.start_date, 'YYYY-MM-DD', true).isValid()) {
                    return moment(row.start_date).format('DD MMM YYYY');
                }
                return this.link(row, row.start_date);
            },

            endDate(data, type, row, meta) {
                if (!row.end_date) return '';
                if (moment(row.end_date, 'YYYY-MM-DD', true).isValid()) {
                    return moment(row.end_date).format('DD MMM YYYY');
                }
                return this.link(row, row.end_date);
            },

            link(row, content, light) {

                // Check if there is a link
                var status_code = row.status;
                if (status_code == 'active' && (row.cohort.status == 'maintenance' || row.program.status == 'maintenance')) {
                    status_code = 'maintenance';
                }

                // No link for maintenance items, when appropriated permission
                var link = true;
                if (status_code == 'maintenance') {
                    link = this.user.admin || this.user.permissions['dashboard.write-all'] || this.user.permissions['dashboard.write-mine-locations']
                        || this.user.permissions['dashboard.read-all'] || this.user.permissions['dashboard.read-mine-locations']
                        || this.user.permissions['registration.manage'];
                }

                // No link
                if (!link) return content;

                // Build the link
                var routes = window.data.program_dashboard_routes;
                var href = routes[row.program.type]+'/registration/'+row.id;
                var myclass = '';
                if (light) myclass = ' class="trax-text-light" ';
                return '<a href="'+href+'" '+myclass+'>'+content+'</a>';
            },

            pinHtml(registration) {
                if (!this.filterPermission) {
                    return ''
                }
                let color = registration.is_pinned ? 'text-info' : 'text-mutted'
                let html = '<div class="btn btn-link btn-just-icon btn-sm '+color+'" data-id="'+registration.id+'">'
                html += '   <i class="material-icons">location_on</i>'
                html += '</div>'
                return html
            },

            filterPermission() {
                return this.user.admin 
                    || this.user.permissions['dashboard.read-mine-locations']
                    || this.user.permissions['dashboard.read-all']
                    || this.user.permissions['dashboard.write-mine-locations']
                    || this.user.permissions['dashboard.write-all'];
            },

            pinIt(registrationId) {
                axios.post(
                    this.endpoint + '/' + registrationId + '/pin',
                )
                .then(response => {
                    this.$refs.registrations.refresh();
                })
                .catch(error => {
                    this.$auth.handleErrorVm(error, this)
                })
            },
        }
    }
</script>
